// removed by extract-text-webpack-plugin
module.exports = {"workCategories":"_3M0xlKFX2zS9qQmVSS0Aem","workCategory":"_3F0lykzh4104-t6qGBCtzt"};


/*****************
 ** WEBPACK FOOTER
 ** ../components/PortfolioSection.module.scss
 ** module id = 1750
 ** module chunks = 0
 **/